module.exports = __webpack_public_path__ + "img/Fort McPherson Station Concepts_Page_2.5a3483c6.jpg";